import { Y as attr, S as bind_props, Z as ensure_array_like, V as spread_props, _ as store_get, $ as unsubscribe_stores, Q as slot, a4 as element, U as attributes, W as clsx, a2 as stringify } from "./index2.js";
import { A as Animate } from "./Animate.js";
import { i as DownloadButton, p as page, I as Icon } from "./stores.js";
import { P as PurchaseButton } from "./PurchaseButton.js";
import { e as escape_html } from "./render-context.js";
import { L as Link } from "./Link.js";
import { e as cn } from "./Icon4.js";
import { tv } from "tailwind-variants";
const brightnessModeDemo = "/_app/immutable/assets/brightness-mode-demo.CKHHBi1W.mp4";
const scheduleChangeDemo = "/_app/immutable/assets/schedule-change-demo.BNQcyrKO.mp4";
const globalChangeDemo = "/_app/immutable/assets/global-change-demo.C3nU2iTg.mp4";
function Highlight($$renderer, $$props) {
  let video = $$props["video"];
  let title = $$props["title"];
  let description = $$props["description"];
  $$renderer.push(`<div class="bg-white gap-4 flex flex-col"><video autoplay class="rounded-3xl" loop muted playsinline${attr("src", video)}></video> <h3 class="text-2xl font-display font-bold mt-4">${escape_html(title)}</h3> <span class="text-xl leading-relaxed opacity-70">${escape_html(description)}</span></div>`);
  bind_props($$props, { video, title, description });
}
function Highlights($$renderer) {
  const features = [
    {
      video: brightnessModeDemo,
      title: "Create & Apply Custom Brightness Modes",
      description: "Whether you're working, gaming, or watching a movie, with just a few clicks, you can set the perfect brightness for your display."
    },
    {
      video: scheduleChangeDemo,
      title: "Use Custom Schedules to Automate Brightness Changes",
      description: "Create custom schedules to automatically adjust your display's brightness without lifting a finger."
    },
    {
      video: globalChangeDemo,
      title: "Adjust Displays Individually or in Sync",
      description: "Change the brightness of all your displays at once or adjust them individually to suit your needs."
    }
  ];
  $$renderer.push(`<div class="section-container"><div class="section grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12"><!--[-->`);
  const each_array = ensure_array_like(features);
  for (let i = 0, $$length = each_array.length; i < $$length; i++) {
    let feature = each_array[i];
    Highlight($$renderer, spread_props([feature]));
  }
  $$renderer.push(`<!--]--></div></div>`);
}
function TrustedBy($$renderer, $$props) {
  $$renderer.component(($$renderer2) => {
    var $$store_subs;
    $$renderer2.push(`<div class="section-container"><div class="section text-white bg-teal-950 rounded-3xl flex flex-col md:flex-row gap-12 items-center justify-between py-24"><span class="text-4xl text-center 2xl:text-left font-display font-bold">Join our growing family of <span class="text-teal-500">${escape_html(store_get($$store_subs ??= {}, "$page", page).data.userCount.toLocaleString())}</span> satisfied users!</span> `);
    DownloadButton($$renderer2, { background: "dark", primary: false, size: 2 });
    $$renderer2.push(`<!----></div></div>`);
    if ($$store_subs) unsubscribe_stores($$store_subs);
  });
}
function SplitScreen($$renderer, $$props) {
  $$renderer.push(`<div class="w-full grid grid-cols-1 lg:grid-cols-4 gap-24 items-center">`);
  Animate($$renderer, {
    class: "col-span-2",
    children: ($$renderer2) => {
      $$renderer2.push(`<!--[-->`);
      slot($$renderer2, $$props, "left", {});
      $$renderer2.push(`<!--]-->`);
    },
    $$slots: { default: true }
  });
  $$renderer.push(`<!----> `);
  Animate($$renderer, {
    class: "col-span-2",
    children: ($$renderer2) => {
      $$renderer2.push(`<!--[-->`);
      slot($$renderer2, $$props, "right", {});
      $$renderer2.push(`<!--]-->`);
    },
    $$slots: { default: true }
  });
  $$renderer.push(`<!----></div>`);
}
const demo = "/_app/immutable/assets/demo.YtskN_MP.mp4";
function Intro($$renderer) {
  $$renderer.push(`<section class="section-container"><div class="section p-36 rounded-3xl bg-teal-900/5 text-black">`);
  SplitScreen($$renderer, {
    $$slots: {
      left: ($$renderer2) => {
        $$renderer2.push(`<div slot="left"><video autoplay class="w-full h-full rounded-3xl" loop muted playsinline><source${attr("src", demo)} type="video/mp4"/></video></div>`);
      },
      right: ($$renderer2) => {
        $$renderer2.push(`<div slot="right"><div class="space-y-8 flex flex-col items-center max-w-lg mx-auto text-center">`);
        Icon($$renderer2, {
          class: "text-6xl text-teal-900",
          icon: "mdi:cursor-default-click"
        });
        $$renderer2.push(`<!----> `);
        Animate($$renderer2, {
          children: ($$renderer3) => {
            $$renderer3.push(`<h2 class="text-teal-900 text-4xl md:text-5xl lg:text-6xl font-display leading-tight font-bold">Accessible &amp; Convenient</h2>`);
          },
          $$slots: { default: true }
        });
        $$renderer2.push(`<!----> `);
        Animate($$renderer2, {
          children: ($$renderer3) => {
            $$renderer3.push(`<p class="opacity-70 font-display text-xl lg:text-2xl !leading-relaxed">No more fiddling with display settings or dealing with the dreaded
							Windows brightness slider. All your displays will be automatically
							detected and available for adjustment.</p>`);
          },
          $$slots: { default: true }
        });
        $$renderer2.push(`<!----></div></div>`);
      }
    }
  });
  $$renderer.push(`<!----></div></section>`);
}
const badgeVariants = tv({
  base: "focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive inline-flex w-fit shrink-0 items-center justify-center gap-1 overflow-hidden rounded-full border px-2 py-0.5 text-xs font-medium whitespace-nowrap transition-[color,box-shadow] focus-visible:ring-[3px] [&>svg]:pointer-events-none [&>svg]:size-3",
  variants: {
    variant: {
      default: "bg-primary text-primary-foreground [a&]:hover:bg-primary/90 border-transparent",
      secondary: "bg-secondary text-secondary-foreground [a&]:hover:bg-secondary/90 border-transparent",
      destructive: "bg-destructive [a&]:hover:bg-destructive/90 focus-visible:ring-destructive/20 dark:focus-visible:ring-destructive/40 dark:bg-destructive/70 border-transparent text-white",
      outline: "text-foreground [a&]:hover:bg-accent [a&]:hover:text-accent-foreground"
    }
  },
  defaultVariants: { variant: "default" }
});
function Badge($$renderer, $$props) {
  $$renderer.component(($$renderer2) => {
    let {
      ref = null,
      href,
      class: className,
      variant = "default",
      children,
      $$slots,
      $$events,
      ...restProps
    } = $$props;
    element(
      $$renderer2,
      href ? "a" : "span",
      () => {
        $$renderer2.push(`${attributes({
          "data-slot": "badge",
          href,
          class: clsx(cn(badgeVariants({ variant }), className)),
          ...restProps
        })}`);
      },
      () => {
        children?.($$renderer2);
        $$renderer2.push(`<!---->`);
      }
    );
    bind_props($$props, { ref });
  });
}
function Features($$renderer, $$props) {
  $$renderer.component(($$renderer2) => {
    const features = [
      {
        icon: "light_mode",
        title: "Adjust Brightness",
        description: "Effortlessly adjust display brightness individually or in sync with other displays."
      },
      {
        icon: "schedule",
        title: "Scheduling",
        description: "Easily modify brightness levels based on the time of day.",
        pro: true
      },
      {
        icon: "sync_saved_locally",
        title: "Universal Compatibility",
        description: "Unlike other brightness tools, Glimmr works with all display types, regardless of connection type."
      },
      {
        icon: "model_training",
        title: "Brightness Profiles",
        description: "Easily switch between different presets with just a few clicks."
      },
      {
        icon: "donut_small",
        title: "Shade Mode",
        description: "Artificially control brightness levels on displays that don't support native adjustments.",
        pro: true
      },
      {
        icon: "rocket_launch",
        title: "Auto Startup",
        description: "Glimmr starts up with Windows by default and automatically applies your predefined brightness adjustments."
      }
    ];
    Highlights($$renderer2);
    $$renderer2.push(`<!----> `);
    TrustedBy($$renderer2);
    $$renderer2.push(`<!----> `);
    Intro($$renderer2);
    $$renderer2.push(`<!----> <div class="section-container bg-teal-900/10 mt-24"><div class="section py-24"><div class="grid grid-cols-1 gap-12 items-center z-10 relative"><div class="mx-auto max-w-4xl text-center"><span class="text-base/7 font-semibold text-teal-600 font-display">Features</span> <h2 class="mt-2 font-display text-balance text-5xl font-semibold tracking-tight text-teal-900 sm:text-6xl">Designed for Simplicity</h2></div> <section class="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 p-2 md:p-0"><!--[-->`);
    const each_array = ensure_array_like(features);
    for (let i = 0, $$length = each_array.length; i < $$length; i++) {
      let feature = each_array[i];
      $$renderer2.push(`<div class="w-full h-full flex items-stretch justify-stretch">`);
      Animate($$renderer2, {
        class: "flex-grow",
        children: ($$renderer3) => {
          $$renderer3.push(`<section class="p-4 md:p-12 gap-8 h-full text-left flex flex-col"><div class="flex flex-col items-center justify-center size-16 p-12 bg-white text-teal-500 rounded-3xl"><span class="material-symbols-outlined !text-5xl">${escape_html(feature.icon)}</span></div> <div class="flex flex-col gap-4"><div class="flex items-center justify-between"><h1 class="text-4xl font-display text-teal-900 leading-tight font-bold">${escape_html(feature.title)}</h1> `);
          if (feature.pro) {
            $$renderer3.push("<!--[-->");
            $$renderer3.push(`<a${attr("href", `/pricing?feature=${stringify(feature.title.toLowerCase().replace(" ", "-"))}`)}>`);
            Badge($$renderer3, {
              class: "bg-teal-500 text-white hover:bg-teal-400",
              children: ($$renderer4) => {
                $$renderer4.push(`<!---->PRO`);
              },
              $$slots: { default: true }
            });
            $$renderer3.push(`<!----></a>`);
          } else {
            $$renderer3.push("<!--[!-->");
          }
          $$renderer3.push(`<!--]--></div> <p class="text-xl opacity-80 leading-relaxed">${escape_html(feature.description)}</p></div></section>`);
        },
        $$slots: { default: true }
      });
      $$renderer2.push(`<!----></div>`);
    }
    $$renderer2.push(`<!--]--></section> <div class="mx-aut flex flex-col items-center gap-8"><div class="flex gap-2 flex-col md:flex-row">`);
    DownloadButton($$renderer2, { size: 4 });
    $$renderer2.push(`<!----> `);
    PurchaseButton($$renderer2, { context: "features", size: 4 });
    $$renderer2.push(`<!----></div> `);
    Link($$renderer2, {
      to: "/pricing",
      children: ($$renderer3) => {
        $$renderer3.push(`<!---->View Pricing`);
      },
      $$slots: { default: true }
    });
    $$renderer2.push(`<!----></div></div></div></div>`);
  });
}
export {
  Features as F,
  SplitScreen as S
};
